// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import { sync } from 'vuex-router-sync';
import { get } from 'lodash';
import BootstrapVue from 'bootstrap-vue';
import VeeValidate from 'vee-validate';
import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';
import VueSweetalert2 from 'vue-sweetalert2';
import Viewer from 'v-viewer';
import Swatches from 'vue-swatches';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';
import SweetModal from 'sweet-modal-vue/src/plugin.js';
import '../node_modules/timeline-vuejs/dist/timeline-vuejs.css';

import config from './config';
import App from './App';
import router from './router';
import store from './store';

sync(store, router);

Sentry.init({
  Vue,
  dsn: 'https://3aab9faadb684b5fb0fae2ab6c8a3156@svr221.street-directory.com.au:9001/13',
  tunnel: config.tmsSentry,
  integrations: [
    new Integrations.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: [
        /^\//,
      ],
    }),
  ],
  tracesSampleRate: 1,
});

const VeeConfig = {
  errorBagName: 'errors',
  fieldsBagName: 'inputs ',
};

Vue.use(BootstrapVue);
Vue.use(VeeValidate, VeeConfig);
Vue.use(Viewer, {
  debug: false,
  defaultOptions: {
    zIndex: 9999,
  },
});
Vue.use(VueSweetalert2);
Vue.use(Swatches);
Vue.use(SweetModal);

const checkMeta = (item) => {
  const { userData } = store.state;
  let userType = true;
  if (item.userTypes && item.userTypes.length) {
    if (item.userTypes.indexOf(userData.type) < 0) {
      userType = false;
    }
  }
  let accessKey = true;
  if (typeof item.accessKey === 'string') {
    accessKey = !!get(userData.account.access, item.accessKey);
  }
  let filter = true;
  if (typeof item.filter === 'function') {
    filter = item.filter(userData);
  }

  return userType && accessKey && filter;
};

const checkAccess = (matched) => {
  for (let i = 0; i < matched.length; i++) {
    if (checkMeta(matched[i].meta) === false) {
      return false;
    }
  }

  return true;
};

router.beforeEach((to, from, next) => {
  store.commit('CLEAR_BREADCRUMB_ITEM');
  if (store.state.loggedIn && to.path === '/login') {
    next('/dashboard');
  } else if (!store.state.loggedIn && to.path !== '/login') {
    next({
      path: '/login',
      // query: {
      //   redirect: to.fullPath
      // }
    });
  } else if (!to.matched.length) {
    next('/404');
  } else if (!checkAccess(to.matched)) {
    next('/403');
  } else {
    next();
  }
});

const setBrowserId = (socketInstance) => {
  if (store.getters.browserId && socketInstance.connected) {
    socketInstance.emit('set_browser_id', store.getters.browserId);
  }
};

const enableSocketIO = true;

store.dispatch('LOAD_LOGIN_STATE').then(async () => {
  let socketInstance = null;

  if (enableSocketIO) {
    socketInstance = socketio(config.tmsSocketIoUrl, {
      path: config.tmsSocketIoPath,
    });
    store.commit('SET_SESSION_ID', window.performance.now());
    Vue.use(VueSocketIO, socketInstance);
    await store.dispatch('INIT_BROWSER_ID');
    setBrowserId(socketInstance);
  }

  /* eslint-disable no-new */
  new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: {
      App,
    },
    sockets: {
      connect() {
        if (enableSocketIO) {
          if (store.getters.isLoggedIn) {
            socketInstance.emit('authorize', store.getters.token);
          }
          setBrowserId(socketInstance);
        }
      },
      self_message({ action, data }) {
        data = data || {}; // eslint-disable-line
        if (action === 'reload') {
          location.href = data.destination || '/'; // eslint-disable-line
        } else if (action === 'logout') {
          if (enableSocketIO) {
            socketInstance.emit('deauthorize');
          }
          location.reload(); // eslint-disable-line
        }
      },
    },
  });
});



// WEBPACK FOOTER //
// ./src/main.js